import React, {useEffect, useState} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Typography } from '@mui/material';
import  PropTypes from 'prop-types';
import { useAuth } from '../../../../hooks/useAuth';
import { blue } from '@mui/material/colors';
import config from '../../../../config-site';

const address_api = config[0].address;

export default function SelectSearchAuto({onClose, dataAll, selectedValue, title}) {
    const { authDataLang } = useAuth()

    const [dataShow, setDataShow] = useState('')
    const [dataActive, setDataActive] = useState('')
    
    useEffect(() =>{
      // console.log("SelectSearchAuto", dataAll)
      setDataActive(selectedValue)
      setDataShow(dataAll)
        // if(selectedValue && dataAll){
        //     const nameList = selectedValue.map((ee) => dataAll.filter(v => v.id === ee)[0]['name'])
        //     setDataShow(
        //         // On autofill we get a stringified value.
        //         typeof nameList === 'string' ? nameList.split(',') : nameList,
        //     )
        // }
        // const users = async() => {
        //     setLoading(true)
        //     setError(false)
        //     await getUsers(authData?.token)
        //     .then(data => {
        //         setLoading(false)
        //         console.log("SelectSearchAuto", data?.results)
        //         setDataShow(data?.results)
        //     }).catch(err => {
        //         setError(true)
        //         setLoading(false)
        //     })
        // }
        // if(isAdmin){
        //     users()
        // }
    }, [dataAll, selectedValue])
    // if (error) return <h1> Error </h1> 
    // if (loading) return <ProgressWait /> 

    const handleListItemClick = value => {
        setDataActive(value)
        onClose(value)
    }

  return (
    <Autocomplete
      defaultValue={dataActive}
      value={dataActive}
      onChange={(event, newValue) => {
          handleListItemClick(newValue)
      }}
      // onClick={(event, newValue) => {
      //     handleListItemClick(newValue)
      // }}
      // inputValue={selectedValue}
      // onInputChange={(event, newInputValue) => {
      //   handleListItemClick(newInputValue)
      // }}
      
      id="mat-select-control"
      sx={authDataLang?.view_sts ? 
        { width: 300, fontFamily: 'b_mitra', fontSize: 24, direction: 'ltr' } 
        : 
        { width: 300, fontFamily: 'b_mitra', fontSize: 24, direction: 'rtl' }
      }
      options={dataShow}
      key={(option) => option.id}
      isOptionEqualToValue={(option, value) =>  option.id === value.id || null || ""}
      autoHighlight
      getOptionLabel={(option) =>  option.last_name || option.username  || null || ""}
      renderOption={(props, option) => (
        <div key={option.id}>
            <Box 
              component="li" 
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} 
              dir={authDataLang?.view_sts ? "rtl" : "ltr"}
              >
              <img
                loading="lazy"
                width="20"
                src={option.image}
                srcSet={`${address_api}${option.profile.image} 2x`}
                alt=""
              />
              
              <Typography
                  fontFamily='b_mitra' 
                  component="div"
                  variant="h6"
                  color={blue[900]}
                  >
                  {option.last_name}-{option.profile.bio}-{option.username}
                  {/* {console.log(option)} */}
              </Typography>
            </Box>
        </div>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={(
              <Typography
                  fontFamily='b_mitra' 
                  component="div"
                  variant="h6"
                  color={blue[900]}
                  >
                  {title}
              </Typography>
          )}

          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            style: { color: blue[900], fontFamily: "b_mitra"}
          }}
        />
      )}
    />
  )
}
// MaterialSelectAuto
// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

SelectSearchAuto.propTypes = {
    onClose: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
}

